import React from 'react'
import { Row, Col, Card, Statistic } from 'antd'
import { UserOutlined } from '@ant-design/icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileInvoiceDollar } from '@fortawesome/free-solid-svg-icons'

const SummaryStatistics = ({ totals }) => {
  return (
    <Row gutter={[12, 16]}>
      <Col span={5}>
        <Card>
          <Statistic title='Total Patients' value={totals.totalPatients || 0} prefix={<UserOutlined />} />
        </Card>
      </Col>
      <Col span={5}>
        <Card>
          <Statistic
            title='Total Outstanding'
            value={totals.totalOutstanding || 0}
            precision={2}
            prefix='R'
            valueStyle={{ color: (totals.totalOutstanding || 0) > 0 ? '#ff4d4f' : '#52c41a' }}
          />
        </Card>
      </Col>
      <Col span={5}>
        <Card>
          <Statistic
            title='Medical Aid Due'
            value={totals.medicalAidOutstanding || 0}
            precision={2}
            prefix='R'
            valueStyle={{ color: '#1890ff' }}
          />
        </Card>
      </Col>
      <Col span={5}>
        <Card>
          <Statistic
            title='Compensation Fund'
            value={totals.compensationOutstanding || 0}
            precision={2}
            prefix={<FontAwesomeIcon icon={faFileInvoiceDollar} style={{ marginRight: 6, fontSize: 14 }} />}
            valueStyle={{ color: '#722ed1' }}
          />
        </Card>
      </Col>
      <Col span={4}>
        <Card>
          <Statistic
            title='Patient Due'
            value={totals.patientOutstanding || 0}
            precision={2}
            prefix='R'
            valueStyle={{ color: '#fa8c16' }}
          />
        </Card>
      </Col>
    </Row>
  )
}

export default SummaryStatistics
